export default __webpack_public_path__ + "static/media/ManHand.adc742be.svg";